module.exports = __webpack_public_path__ + "static/twojabi-opengraph.f48ca7fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twojabi-opengraph.png
// module id = 703
// module chunks = 114276838955818